import { motion } from "framer-motion";
import { Headphones, CheckCircle2 } from "lucide-react";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/51ddf5f6-e80c-4259-9ef6-c5393e7b5903/images/bb4a9f0222b9482b3cb9b7e6623ebc30ad65f40b81c8b43f9745f5e0dea26129.png";

const COLLECTS = [
  "Caller name",
  "Callback number",
  "Service issue",
  "City",
  "Urgency",
  "Preferred appointment window",
];

export default function AIReceptionist() {
  return (
    <section
      data-testid="ai-receptionist-section"
      aria-labelledby="ai-receptionist-heading"
      className="relative bg-white py-20 sm:py-24"
    >
      <div className="container-page grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="lg:col-span-6"
        >
          <span className="pill">
            <Headphones className="h-3 w-3 text-aqua" />
            Backup receptionist concept
          </span>
          <h2
            id="ai-receptionist-heading"
            className="mt-4 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-[2.5rem]"
          >
            A backup receptionist that always picks up.
          </h2>
          <p className="mt-4 max-w-xl text-base text-navy/70 sm:text-lg">
            A simple voice intake can collect the caller&rsquo;s details and
            hand off a clean, organized lead to the team &mdash; even when the
            office is on another call or off the clock.
          </p>

          <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-2.5">
            {COLLECTS.map((c) => (
              <li key={c} className="flex items-center gap-2 text-sm text-navy/85">
                <CheckCircle2 className="h-4 w-4 text-aqua-deep" />
                {c}
              </li>
            ))}
          </ul>

          <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-mist-line bg-mist px-3 py-1.5 text-xs font-medium text-navy/65">
            <span className="h-1.5 w-1.5 rounded-full bg-aqua" />
            Demo concept for contractors &mdash; not a live receptionist for
            Sun Chaser Cooling.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="lg:col-span-6"
        >
          <div className="relative">
            <div className="overflow-hidden rounded-3xl border border-mist-line bg-mist shadow-lift">
              <img
                src={IMG}
                alt="Illustration of an AI voice receptionist concept handling an incoming call for an HVAC company."
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -left-3 bottom-6 hidden rotate-[-3deg] items-center gap-2 rounded-full border border-mist-line bg-white px-3 py-2 text-xs font-medium text-navy/80 shadow-lift sm:inline-flex">
              <span className="relative inline-flex h-2 w-2">
                <span className="absolute inset-0 animate-ping rounded-full bg-aqua/60" />
                <span className="relative inline-block h-2 w-2 rounded-full bg-aqua" />
              </span>
              Live call handoff
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
